// src/data/mockData.js
// Used in demo mode (no Firebase needed). Replace with Firestore calls when going live.

export const CATEGORIES = [
  "All",
  "Physics",
  "Chemistry",
  "Biology",
  "Mathematics",
  "English",
  "ICT",
  "Admission Tips"
];

export const MOCK_VIDEOS = [
  {
    id: "v1",
    title: "Newton's Laws of Motion – Complete Breakdown",
    description: "A clear walkthrough of all three Newton's laws with real-world examples and problem-solving techniques for HSC.",
    category: "Physics",
    thumbnail: "https://img.youtube.com/vi/kKKM8Y-u7ds/hqdefault.jpg",
    youtubeId: "kKKM8Y-u7ds",
    duration: "28:14",
    instructor: "Sir Mahbub",
    views: 4821,
    uploadedAt: "2024-11-10",
    featured: true
  },
  {
    id: "v2",
    title: "Organic Chemistry: Functional Groups Explained",
    description: "Understand all major functional groups with structures, reactions, and naming conventions. Includes MCQ practice.",
    category: "Chemistry",
    thumbnail: "https://img.youtube.com/vi/bhnBOKMEdq0/hqdefault.jpg",
    youtubeId: "bhnBOKMEdq0",
    duration: "35:42",
    instructor: "Sir Rafi",
    views: 3265,
    uploadedAt: "2024-11-15",
    featured: true
  },
  {
    id: "v3",
    title: "Cell Division: Mitosis vs Meiosis",
    description: "Visual guide to cell division stages, differences, and importance in reproduction and growth.",
    category: "Biology",
    thumbnail: "https://img.youtube.com/vi/L0k-enzoeOM/hqdefault.jpg",
    youtubeId: "L0k-enzoeOM",
    duration: "22:05",
    instructor: "Sir Mahbub",
    views: 2190,
    uploadedAt: "2024-11-20",
    featured: false
  },
  {
    id: "v4",
    title: "Calculus Limits – Full Foundation",
    description: "Everything you need to know about limits before diving into differentiation. Built for SSC and HSC students.",
    category: "Mathematics",
    thumbnail: "https://img.youtube.com/vi/riXcZT2ICjA/hqdefault.jpg",
    youtubeId: "riXcZT2ICjA",
    duration: "41:20",
    instructor: "Sir Anik",
    views: 5102,
    uploadedAt: "2024-10-28",
    featured: true
  },
  {
    id: "v5",
    title: "Medical Admission: Strategy & Mistake Analysis",
    description: "Insights from toppers and our advisors on what the MBBS admission test really tests and how to prepare.",
    category: "Admission Tips",
    thumbnail: "https://img.youtube.com/vi/WHbgHkPbnjQ/hqdefault.jpg",
    youtubeId: "WHbgHkPbnjQ",
    duration: "52:18",
    instructor: "Sir Rafi",
    views: 8340,
    uploadedAt: "2024-12-01",
    featured: true
  },
  {
    id: "v6",
    title: "Electricity & Circuits – HSC Chapter 5",
    description: "Kirchhoff's laws, series and parallel circuits, and numerical problem walkthrough.",
    category: "Physics",
    thumbnail: "https://img.youtube.com/vi/F_vLWkkOETI/hqdefault.jpg",
    youtubeId: "F_vLWkkOETI",
    duration: "33:55",
    instructor: "Sir Mahbub",
    views: 2890,
    uploadedAt: "2024-11-05",
    featured: false
  },
  {
    id: "v7",
    title: "Genetic Engineering & Biotechnology",
    description: "Recombinant DNA, PCR, gene cloning, and their applications – simplified for board exam prep.",
    category: "Biology",
    thumbnail: "https://img.youtube.com/vi/QHivX5kTyXI/hqdefault.jpg",
    youtubeId: "QHivX5kTyXI",
    duration: "29:30",
    instructor: "Sir Rafi",
    views: 1875,
    uploadedAt: "2024-12-05",
    featured: false
  },
  {
    id: "v8",
    title: "Writing Formal Emails & Applications",
    description: "Common formats, vocabulary, and common mistakes Bangladeshi students make in formal English writing.",
    category: "English",
    thumbnail: "https://img.youtube.com/vi/1NmGRgGLbcE/hqdefault.jpg",
    youtubeId: "1NmGRgGLbcE",
    duration: "18:40",
    instructor: "Sir Anik",
    views: 1320,
    uploadedAt: "2024-11-25",
    featured: false
  }
];

export const MOCK_STUDENTS = [
  {
    id: "s1",
    name: "Nusrat Jahan",
    email: "nusrat@example.com",
    phone: "01711-223344",
    courseLevel: "HSC",
    joinedAt: "2024-09-15",
    status: "active",
    watchedVideos: ["v1", "v2", "v4"],
    avatar: null
  },
  {
    id: "s2",
    name: "Rafiq Islam",
    email: "rafiq@example.com",
    phone: "01812-556677",
    courseLevel: "SSC",
    joinedAt: "2024-10-02",
    status: "active",
    watchedVideos: ["v3", "v6"],
    avatar: null
  },
  {
    id: "s3",
    name: "Tasnim Akter",
    email: "tasnim@example.com",
    phone: "01912-889900",
    courseLevel: "HSC",
    joinedAt: "2024-10-20",
    status: "suspended",
    watchedVideos: ["v1"],
    avatar: null
  },
  {
    id: "s4",
    name: "Mehedi Hasan",
    email: "mehedi@example.com",
    phone: "01611-001122",
    courseLevel: "Admission",
    joinedAt: "2024-11-05",
    status: "active",
    watchedVideos: ["v2", "v4", "v5", "v7"],
    avatar: null
  },
  {
    id: "s5",
    name: "Sadia Rahman",
    email: "sadia@example.com",
    phone: "01511-334455",
    courseLevel: "HSC",
    joinedAt: "2024-11-18",
    status: "active",
    watchedVideos: ["v1", "v5", "v8"],
    avatar: null
  }
];

// Demo accounts (no Firebase needed)
export const DEMO_ACCOUNTS = {
  "student@demo.com": { password: "demo1234", role: "student", name: "Demo Student" },
  "admin@demo.com": { password: "admin1234", role: "admin", name: "Admin" }
};
